<template>
  <q-page padding>
    <div
      class="row col-12 text-brand-5 container-titulo-principal"
      @click="voltar()"
    >
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="icon-voltar"
      />
      <p class="text-h6 text-brand-5 text-weight-bold titulo-pagina-principal">
        Arquivos Requisição: #{{ requisicaoId }}
      </p>
    </div>
    <div
      style="margin-left: 30px"
      class="text-brand-5 text-h6 text-weight-bold q-mt-md container-input-arquivos"
    >
      <span class="titulo-input-arquivo"> Enviar Documento</span>
    </div>

    <div
      class="row col-12 q-ml-xl text-brand-5 text-weight-bold q-gutter-x-sm input-arquivo-container"
    >
      <div style="margin-top: 31px" class="container">
        <label class="btn info" for="arquivo"> Selecionar Arquivo</label>
        <div
          class="text-brand-5 text-weight-bold text q-ml-sm input-arquivo-text"
        >
          {{ file ? file.name : "Nenhum arquivo escolhido" }}
        </div>
        <input
          id="arquivo"
          @click="resetValue()"
          type="file"
          @change="onFileSelected"
        />
        <span class="icon">
          <img src="../../../assets/file_upload_black.svg" alt="" />
        </span>
      </div>
      <div class="col-md-3 col-xs-5 q-ml-md input-container-descricao">
        <div class="input-arquivo-text">Descrição</div>
        <q-input dense outlined v-model="observacao" />
      </div>
      <div class="btn-enviar-container">
        <p></p>
        <q-btn
          class="q-mt-sm"
          label="Enviar Documento"
          color="positive"
          no-caps
          dense
          icon="check_circle_outline"
          @click="uploadArquivo()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <q-table
        table-header-class="bg-accent text-weight-bold"
        flat
        :columns="columns"
        :loading="loading"
        dense
        color="primary"
        class="tabela-tamanho-fixo"
        :rows="listaArquivos"
        :grid="$q.screen.lt.sm"
        hide-bottom
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
            <div class="row card">
              <div class="col-1 text-center q-mt-lg"></div>
              <div class="col">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12">
                    <span>
                      <strong>Nome: </strong> {{ props.row.nome_arquivo }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span>
                      <strong>Observação: </strong> {{ props.row.observacao }}
                    </span>
                  </div>
                  <div class="col-12">
                    <span>
                      <strong>Data Envio: </strong>
                      {{
                        props.row.created_at
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}
                    </span>
                  </div>
                  <div class="col-12">
                    <span>
                      <strong>Upload Por: </strong>
                      {{ props.row.usuario_nome }}
                    </span>
                  </div>
                </q-card-section>
              </div>
              <div class="col-12">
                <div class="text-brand-5 btn-grid-container">
                  <div class="row">
                    <a class="column col-6" :href="props.row.url" download>
                      <q-btn
                        stack
                        no-caps
                        label="Download"
                        color="positive"
                        icon="file_download"
                        style="border-radius: 0px 0px 0px 5px"
                      />
                    </a>
                    <div class="column col-6">
                      <q-btn
                        stack
                        no-caps
                        label="Remover"
                        color="red"
                        icon="delete"
                        style="border-radius: 0px 0px 5px 0px"
                        @click="removerArquivo(props.row.uuid)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-arquivo="props">
          <q-td :props="props">
            <a :href="props.row.url" download>
              <q-btn color="brand-5" flat icon="open_in_new"
            /></a>
          </q-td>
        </template>
        <template v-slot:body-cell-observacao="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props"
            >{{ props.row.observacao ? props.row.observacao : "Sem Obs." }}
          </q-td>
        </template>
        <template v-slot:body-cell-data="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props">
            <div>
              {{
                props.row.created_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
              <p style="margin: 0 0 0 9px">
                {{ props.row.created_at.split(" ")[1] }}
              </p>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              color="white"
              text-color="red"
              flat
              label="Remover"
              no-caps
              icon="remove_circle_outline"
              @click="removerArquivo(props.row.uuid)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import { onMounted, ref } from "@vue/runtime-core";

export default {
  setup() {
    const columns = [
      {
        name: "arquivo",
        label: "Arquivo",
        align: "left",
        field: "",
      },
      {
        name: "observacao",
        label: "Observação",
        align: "left",
      },
      {
        name: "nome",
        label: "Nome do Arquivo",
        align: "left",
        field: "nome_arquivo",
      },
      {
        name: "uploadpor",
        label: "Upload por",
        align: "left",
        field: "usuario_nome",
      },
      {
        name: "data",
        label: "Data de Envio",
        align: "left",
        field: "dataHoraEnvio",
      },
      {
        name: "remover",
        label: "Remover",
        align: "center",
      },
    ];
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();
    const requisicaoId = route.params.requisicaoId;
    const listaArquivos = ref([]);
    const file = ref(null);
    const observacao = ref(undefined);
    let loading = ref(false);

    const listarArquivos = async () => {
      loading.value = true;
      try {
        let response = await store.dispatch("requisicao/listarDocumentos", {
          voucher_id: requisicaoId,
        });
        listaArquivos.value = response.data.result;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
    };

    const uploadArquivo = async () => {
      if (!file.value) {
        quasar.notify({
          message: "Nenhum arquivo selecionado.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let response = await store.dispatch("requisicao/uploadUrl", {
        nome_arquivo: file.value.name,
      });
      let formAttributes = response.data.result.formAttributes;
      let formInputs = response.data.result.formInputs;

      const formData = new FormData();

      for (let input in formInputs) {
        formData.append(input, formInputs[input]);
      }

      formData.append("file", file.value);
      var request = new XMLHttpRequest();
      request.open(formAttributes.method, formAttributes.action);
      await request.send(formData);

      if (observacao.value == undefined) {
        observacao.value = "Sem Obs.";
      }
      try {
        await store.dispatch("requisicao/uploadDocumento", {
          voucher_id: requisicaoId,
          url: `${formAttributes.action}/${formInputs.key}`,
          observacao: observacao.value,
        });
        quasar.notify({
          message: "Upload de arquivo feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        file.value = null;
        observacao.value = undefined;
        listarArquivos();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao fazer upload de arquivo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = () => {
      router.push({
        name: "requisicao-detalhe",
        params: { requisicaoId: requisicaoId },
      });
    };

    const removerArquivo = async (uuid) => {
      try {
        await store.dispatch("requisicao/deletarDocumentos", {
          uuid: uuid,
        });
        quasar.notify({
          message: "Arquivo removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        observacao.value = "";
        listarArquivos();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao remover arquivo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetValue = () => {
      const input = document.getElementById("arquivo");
      input.value = null;
    };

    onMounted(listarArquivos);
    return {
      requisicaoId,
      listarArquivos,
      columns,
      listaArquivos,
      file,
      onFileSelected,
      uploadArquivo,
      observacao,
      voltar,
      removerArquivo,
      loading,
      resetValue,
    };
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn {
  border: 2px solid black;
  background-color: white;
  color: black;
  border-radius: 5px;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
  cursor: pointer;
  border-color: #2196f3;
  color: #58afc1;
}
.info {
  border-color: #58afc1;
}
.text {
  display: inline;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: -2px;
  left: 9px;
}
.icon-voltar {
  cursor: pointer;
}
a {
  text-decoration: none;
}
@media only screen and (max-width: 635px) {
  .container-input-arquivos {
    margin: 6px 0px 0px 5px !important;
  }
  .input-arquivo-container {
    margin: 0px;
  }
  .btn {
    border: 2px solid black;
    background-color: white;
    color: black;
    border-radius: 5px;
    margin: 5px 5px 0 0;
    padding: 5px 8px;
    padding-left: 40px;
    font-size: 11px;
    cursor: pointer;
    border-color: #2196f3;
    color: #58afc1;
  }
  .info {
    border-color: #58afc1;
  }
  .container-titulo-principal {
    margin-top: 10px;
  }
  .titulo-pagina-principal {
    font-size: 14px;
  }
  .icon-voltar {
    font-size: 15px !important;
    margin-top: 8px !important;
    margin-right: 7px;
  }
  .input-arquivo-text {
    font-size: 12px;
  }
  .input-container-descricao {
    margin: 19px 11px 0px 6px;
  }
  .btn-enviar-container {
    margin: 16px 0px 0px 0px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .titulo-input-arquivo {
    font-size: 13px;
  }
}
</style>
